import request from '@/router/axiosMobile';
const urlPrefix = '/wage'
const token = localStorage.getItem('token')

// 获取雇员信息
export function getEmpInfoByLinkCode(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/getEmpInfoByLinkCode`,
    method: 'post',
    data
  });
}

// 薪税云- 获取验证码
export function sendCheckCode(data) {
  return request({
    url: `${ urlPrefix }/account/logon/sendCheckCode`,
    method: 'post',
    data
  });
}

// 薪税云- 登录
export function userCodeLogonNew(data) {
  return request({
    url: `${ urlPrefix }/account/logon/userCodeLogon`,
    method: 'post',
    data
  });
}
// 薪税云- 登录成功获取token
export function getToken(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/getToken`,
    method: 'post',
    data
  });
}
// 根据短链接获取待开票数据对应的应税地
export function getTaxAreaByLinkCode(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/getTaxAreaByLinkCode`,
    method: 'post',
    data
  });
}
// 查询用户认证状态
export function checkUserStatus(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/checkUserStatus`,
    method: 'post',
    data
  });
}
// 获取电子税务局用户验证码
export function sendSmsCode(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/sendSmsCode`,
    method: 'post',
    data
  });
}
// 税局登录
export function taxLogin(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/login`,
    method: 'post',
    data
  });
}
// 获取税友人脸识别url
export function getUrlByTaskType(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/getUrlByTaskType`,
    method: 'post',
    data
  });
}
// 扫脸认证页面回调
export function urlFeedbackByTaskType(data) {
  return request({
    url: `${ urlPrefix }/inv-user-auth/urlFeedbackByTaskType`,
    method: 'post',
    data
  });
}
